import { LanguageSupport, LRLanguage } from '@codemirror/language';

import { filterFieldParser } from '../parser/filterfield-parser.js';

const filterFieldLanguage = LRLanguage.define({
  parser: filterFieldParser,
  name: 'FilterFieldLang',
});

/** @internal */
export const filterFieldLanguageExtension = new LanguageSupport(
  filterFieldLanguage,
);
